<template>
  <div>
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目进展报告</span>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="reportId" :loading="recordsLoading" :pagination="false" :data-source="records" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="报告名称" data-index="reportName" align="left">
          <template slot-scope="text, record">
            <router-link :to="{ path: '../report-detail', query: { id: record.projectId, rid: record.reportId } }" class="text-indigo hover-line" :title="record.reportName">{{ record.reportName }}</router-link>
          </template>
        </a-table-column>
        <a-table-column title="报告类型" data-index="type" align="left">
          <template slot-scope="text, record">
            <a-tag color="#3f51b5" v-if="record.type == 1">月报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 2">季报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 3">年报</a-tag>
            <a-tag color="#3f51b5" v-else-if="record.type == 4">重大活动报告</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="创建/提交日期" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template v-if="record.state === 0 || record.state === -1">{{ record.createTime ? record.createTime.substring(0, 16) : '' }}</template>
            <template v-else>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="quantity" :width="130" align="left">
          <template slot-scope="text, record">
            <span v-if="record.state == 0">初稿</span>
            <span class="text-red" v-else-if="record.state == -1">已驳回</span>
            <span v-else-if="record.state == 9">审核通过</span>
            <span class="text-red" v-else>待审核</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="center">
          <template slot-scope="text, record">
            <a-space :size="10">
              <template v-if="record.state === 0 || record.state === -1">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`../report/draft?id=${projectId}&rid=${record.reportId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDel(record.reportId)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`../report/detail?id=${projectId}&rid=${record.reportId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listReport, delReport } from '@/api/project/common'
export default {
  name: 'ProjectBudget',
  data() {
    return {
      projectId: null,
      records: [],
      recordsLoading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadRecords()
      }
    },
    loadRecords(page = 1, pageSize = 10, sorter) {
      this.recordsLoading = true
      let params = {
        projectId: this.projectId,
        page,
        pageSize,
        sorter,
        origin: 2,
      }
      listReport(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          this.records = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.recordsLoading = false
      })
    },
    onPageChange(page, pageSize) {
      this.loadRecords(page, pageSize)
    },
    handleDel(applyId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delReport(applyId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadRecords()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {});
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
